import { Job, Job$Status } from '@/types/Job';
import { UploadInfo, UploadStatus } from '@/types/Upload';

export default function isBlockingJob(job: Job, upload: UploadInfo) {
  const blockingJobState = job?.state === Job$Status.RUNNING || job?.state === Job$Status.QUEUED;

  const blocking =
    (upload && upload?.status !== UploadStatus.PROCESSING && blockingJobState) ||
    (job && blockingJobState);

  return blocking;
}
